import { jsx as _jsx } from "react/jsx-runtime";
import { RootHydrateFallback, SvgIcon } from '@/core/ui';
import { NoAccess, NotFound } from '@/shared/components';
import { initiateAuthUser, validateToken } from '@/shared/modules/auth/business/thunk';
import { NavLink, createBrowserRouter } from 'react-router-dom';
import { AuthorizedLayout, NavigateToMainPage } from './components';
import { crossdockBlockedRoute, crossdockReceiptRoutes, packingRoute, pickingRoutes, placementRoutes, settingsRoute, shippingRoute, stockBlockedRoute, stockReceiptRoutes, stocksRoute, } from './routes';
import { t } from '@/core/localization';
import houseIcon from '@/core/svg/fa/house.svg';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { getAccessDeniedMessage } from '@/warehouse/helpers/getAccessDeniedMessage';
import { initiateCrossdocksAndLocations } from '@/warehouse/modules/stocks/business/thunk';
import { store } from '@/warehouse/store';
// Multiple Routes in a single file.
// If you want to avoid loading multiple chunks for **nested** routes, you could store them all in the same file and
// return them to the individual routes. Modern bundlers will latch onto the same Promise for the different
// import() invocations.
// Example below: <CrossdockingReceipt /> and <CrossdockingReceiptItems /> both have the same import path and therefore
// have a single chunk.
export async function rootLoader({ params }) {
    try {
        // The following method (direct result return) required `useLoaderData` hook to be used, but this hook adds
        // additional rerender to component!
        // return store.dispatch(initiateCrossdocksAndLocations(params)).unwrap();
        // TODO: to delete the comment later
        // await store.dispatch(validateToken()).unwrap();
        const tokenValidationResult = await store.dispatch(validateToken());
        if (tokenValidationResult.meta.requestStatus !== 'fulfilled') {
            return;
        }
        const rootTask1 = store.dispatch(initiateAuthUser());
        const rootTask2 = store.dispatch(initiateCrossdocksAndLocations(params));
        const [result1, result2] = await Promise.all([rootTask1, rootTask2]);
        let errorMessage;
        if (result1.meta.requestStatus === 'rejected') {
            errorMessage = result1.payload?.errorMessage;
        }
        else if (result2.meta.requestStatus === 'rejected') {
            errorMessage = getAccessDeniedMessage(result2.payload);
        }
        useLayoutStore.getState().saveWarehouseAccessDeniedMessage(errorMessage);
    }
    catch (error) {
        console.error(`Unexpected root loader error: `, error);
        return error;
    }
}
export const router = createBrowserRouter([
    {
        path: 'login',
        lazy: async () => {
            const { Login } = await import('@/shared/modules/auth/Login');
            return { Component: Login };
        },
    },
    {
        path: '/',
        Component: AuthorizedLayout,
        loader: rootLoader,
        HydrateFallback: () => _jsx(RootHydrateFallback, { caption: t('access.levels.loading.spinner.caption') }),
        handle: {
            crumb: () => (_jsx(NavLink, { to: "/", title: "home", children: _jsx(SvgIcon, { icon: houseIcon, size: "sm" }) })),
        },
        children: [
            // Homepage
            {
                path: '/',
                element: _jsx(NavigateToMainPage, {}),
            },
            ...crossdockReceiptRoutes,
            // TODO: to delete later. Placement section must be deleted.
            ...placementRoutes,
            packingRoute,
            shippingRoute,
            crossdockBlockedRoute,
            ...pickingRoutes,
            ...stockReceiptRoutes,
            stocksRoute,
            stockBlockedRoute,
            settingsRoute,
            { path: 'access', element: _jsx(NoAccess, {}) },
            { path: '*', element: _jsx(NotFound, {}) },
        ],
    },
]);
